export default {
  banner: {
    description:
      'Zamów przez bezpłatną aplikację FoodAmigos i zyskaj {{range}} rabatu. Kliknij tutaj, aby pobrać aplikację →',
  },
  labels: {
    deals: 'Oferty',
    collecting_points: 'Zbierasz już punkty?',
    earn_points: 'Zdobywaj punkty i odbieraj nagrody',
    order_again: 'Zamów ponownie',
  },
  checkout_button: {
    title: 'Przejdź do koszyka',
  },
};
